import { Page404View } from "@components/views/Page404View";

const Page404 = () => {
	return <Page404View />;
};

export default Page404;
